import client from 'libs/HttpClient';
class HomeService {
  static getHomeData() {
    return client.get('/get-home-page-details');
  }
}
export { HomeService };
